<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img src="~@/assets/img/CITEditor/font_family.svg" alt="font family" title="font family" />
    </button>
    <div v-show="option" class="optionGroup">
      <button type="button" class="optionItem"
        @mousedown.prevent
        @click="onSelectOption($event, defaultValue)">
        default
      </button>
      <button type="button" class="optionItem"
        v-for="val in fontList"
        :key="val"
        :style="{fontFamily: val}"
        :class="{active: val === value}"
        @mousedown.prevent
        @click="onSelectOption($event, val)">{{val}}</button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'FontFamily',
  props: [
    'active',
    'value',
    'option'
  ],
  computed: {
    defaultValue () {
      return this.$store.state.setting.font.default
    },
    fontList () {
      return this.$store.getters['setting/getFonts']
    }
  },
  methods: {
    // open option:: fontfamily
    onClickOption (e) {
      this.$emit('setOption', { name: 'FontFamily', state: true })
    },
    // select option
    onSelectOption (e, val) {
      e.preventDefault()
      document.execCommand('styleWithCSS', false, true)
      document.execCommand('FontName', false, val)
      this.$emit('setValue', { name: 'FontFamily', value: val })
    }
  }
}
</script>
